export const isDev = process.env.NODE_ENV === 'development';

export const isSatusCodeValid = (statusCode: number) =>
  !statusCode ? false : statusCode.toString().startsWith('2');
